/**
 * Sample-size recommendation — two methodologies offered side by side.
 *
 *  - statistical (population-band lookup): >250 -> 25; 100-250 -> 15; 25-99 -> 10;
 *    <25 -> full population.
 *  - aicpa (frequency-based attribute sampling): mirrors the backend
 *    recommend_sample_size ranges; uses the midpoint as the suggested size.
 */

export function bandSampleSize(population) {
  const n = Number(population) || 0;
  if (n <= 0) return { size: null, rationale: 'Upload a population to size the sample.' };
  if (n < 25) return { size: n, rationale: `Population (${n}) below 25 — test the full population.` };
  if (n <= 99) return { size: 10, rationale: 'Population 25–99 — 10 samples (statistical lookup).' };
  if (n <= 250) return { size: 15, rationale: 'Population 100–250 — 15 samples (statistical lookup).' };
  return { size: 25, rationale: 'Population > 250 — 25 samples (statistical lookup).' };
}

const AICPA_RANGES = {
  annual:        [1, 1],
  'half-yearly': [1, 2],
  quarterly:     [2, 5],
  monthly:       [2, 5],
  'semi-monthly':[3, 8],
  weekly:        [5, 15],
  'bi-weekly':   [3, 8],
  daily:         [20, 40],
  'event-based': [25, 60],
};

export function aicpaSampleSize(frequency, population) {
  const range = AICPA_RANGES[String(frequency || '').toLowerCase()];
  if (!range) return { size: null, rationale: `No AICPA guidance for frequency "${frequency}".` };
  let [min, max] = range;
  const n = Number(population) || 0;
  if (n > 0 && n < min) return { size: n, rationale: `Population (${n}) below minimum — test full population.` };
  const size = Math.round((min + max) / 2);
  return { size, rationale: `${frequency} control — AICPA attribute sampling ${min}–${max}.` };
}

export function recommendSamples(method, { frequency, population } = {}) {
  return method === 'aicpa' ? aicpaSampleSize(frequency, population) : bandSampleSize(population);
}
